import { render, staticRenderFns } from "./SanityLanderHeader.vue?vue&type=template&id=54e132ea&scoped=true"
import script from "./SanityLanderHeader.vue?vue&type=script&lang=js"
export * from "./SanityLanderHeader.vue?vue&type=script&lang=js"
import style0 from "./SanityLanderHeader.vue?vue&type=style&index=0&id=54e132ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e132ea",
  null
  
)

export default component.exports